// extracted by mini-css-extract-plugin
export var scrollArea = "_ou-0";